import React, { useState } from 'react';
import { useMonitoring } from '../context/MonitoringContext';
import ServerFleetList from '../components/ServerFleetList';
import LogsModal from '../components/LogsModal';

export default function Servers() {
    const {
        servers,
        loadingServers,
        refreshData,
        triggerServerAction,
        triggerUpdateAll,
        updateLogs,
        priceLogs,
        refreshRate,
        setRefreshRate,
    } = useMonitoring();

    const [modalServerId, setModalServerId] = useState(null);

    return (
        <>
            <header className="dashboard-header">
                <div className="dashboard-title-area">
                    <h1>Servers</h1>
                </div>
            </header>

            <div className="portal-stack">
                <ServerFleetList
                    servers={servers}
                    onTriggerAction={triggerServerAction}
                    onViewLogs={(sid) => setModalServerId(sid)}
                    onRefresh={refreshData}
                    onUpdateAll={triggerUpdateAll}
                    loading={loadingServers}
                    refreshRate={refreshRate}
                    setRefreshRate={setRefreshRate}
                />
            </div>

            {modalServerId && (
                <LogsModal
                    serverId={modalServerId}
                    updateLogs={updateLogs}
                    priceLogs={priceLogs}
                    onClose={() => setModalServerId(null)}
                />
            )}
        </>
    );
}
